import React from 'react';
import { Form } from 'react-bootstrap';
import {
  useGetAssignmentIncompleteScoringOptionMutation,
  useGetScoreReportMutation,
  useGetAssignmentPointsOPtionsMutation,
  usePatchAssignmentIncompleteScoringOptionMutation,
  usePatchAssignmentPointsOPtionsMutation
} from '../../../../../../features/authentication/reportApiSlice';
import { useNavigate } from 'react-router-dom';
import { faCircleInfo, faInfo } from '@fortawesome/free-solid-svg-icons';
import { useDispatch, useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faX } from '@fortawesome/pro-light-svg-icons';
import {
  selectFerpaState,
  setFerpaState
} from '../../../../../../features/authentication/authSlice';
import { faCheck, faClose } from '@fortawesome/free-solid-svg-icons';
import { useParams } from 'react-router-dom';
import DropDown from '../../../../../../components/DropDown';
import CustomToast from '../../../../../../components/Toast';
import { useShowIdentificationFieldsMutation } from '../../../../../../features/authentication/assignApiSlice';
import HesSpinner from '../../../../../../components/loadingOverlay/hesSpinner';
import { useLazyGetAssignmentQuery } from '../../../../../../features/authentication/assignmentApislice';
import {
  convertToCSV,
  downloadCSV,
  reorderObjectProperties
} from '../../../../utils';
import html2pdf from 'html2pdf.js';

const ScoreReport = () => {
  const [getScoreReport] = useGetScoreReportMutation();
  const navigate = useNavigate();
  const [showFerpa, setShowFerpa] = React.useState(false);
  const [showIdentificationFields] = useShowIdentificationFieldsMutation();
  const [loader, setLoader] = React.useState(false);
  const [ScoreReportData, setScoreReportData] = React.useState([]);
  const [incompleteScoringOption, setIncompleteScoringOption] = React.useState(false);
  const dispatch = useDispatch();
  const [classList, setClassList] = React.useState([]);
  const [selectedClassIds, setSelectedClassIds] = React.useState(-1);
  const [ferpaEnabled, setFerpaEnabled] = React.useState(useSelector(selectFerpaState));
  const [getAssignmentIncompleteScoringOption] = useGetAssignmentIncompleteScoringOptionMutation();
  const [getAssignmentPointsOPtions] = useGetAssignmentPointsOPtionsMutation();
  const [patchAssignmentPointsOPtions] = usePatchAssignmentPointsOPtionsMutation();
  const [scoringOption, setScoringOption] = React.useState({
    point: false,
    percentage: false
  });
  const [patchAssignmentIncompleteScoringOption] =
    usePatchAssignmentIncompleteScoringOptionMutation();
  const { Id } = useParams();
  let pageNumber = 0;
  const [trigger] = useLazyGetAssignmentQuery({
    assignmentId: Id,
    pageNumber: pageNumber
  });
  const [selectedClassName, setSelectedClassName] = React.useState('');
  const [isClassChanged, setIsClassChanged] = React.useState(false);
  const [isNoData, setIsNoData] = React.useState(false);
  const [pageLoader, setPageLoader] = React.useState(true);

  React.useEffect(() => {
    refetch();
    getIncompleteScoringOption();
    getPointOptions();
    fetchScoreReportData();
  }, []);

  React.useEffect(() => {
    fetchScoreReportData();
  }, [isClassChanged]);

  const getIncompleteScoringOption = async () => {
    try {
      const response = await getAssignmentIncompleteScoringOption().unwrap();
      setIncompleteScoringOption(response);
    } catch (error) {
      console.log(error);
    }
  };

  const getPointOptions = async () => {
    const option = {
      option: 'true'
    };
    try {
      const response = await getAssignmentPointsOPtions(option).unwrap();
      if (response) {
        setScoringOption({
          point: true,
          percentage: false
        });
      } else {
        setScoringOption({
          point: false,
          percentage: true
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleFerpaChange = async (e) => {
    setFerpaEnabled(!ferpaEnabled);
    dispatch(
      setFerpaState({
        ferpaEnabled: e.target.checked
      })
    );
    const data = {
      condition: e.target.checked
    };
    try {
      await showIdentificationFields(data).unwrap();
    } catch (error) {
      console.log(error);
    }
  };

  const refetch = () => {
    trigger({ assignmentId: Id, pageNumber: pageNumber }).then((response) => {
      if (!response.isSuccess) {
        return;
      }
      setClassList([
        {
          name: 'All Classes',
          id: -1,
          description: 'All Classes',
          isChecked: true
        },
        ...response.data.classes.map((item) => ({
          name: item.name,
          id: item.id,
          description: item.name,
          isChecked: true
        }))
      ]);
    });
  };

  const fetchScoreReportData = async () => {
    setLoader(true);
    const data = {
      assignmentId: Id,
      classId: selectedClassIds,
      publicAssignmentId: 0,
      teacherId: 0
    };

    try {
      const response = await getScoreReport(data).unwrap();
      setScoreReportData(response);
      setLoader(false);
      setIsNoData(false);
    } catch (error) {
      setLoader(false);
      CustomToast(error.data, 'error');
      console.log(error);
      setIsNoData(true);
    }
    setPageLoader(false);
  };

  const handleClassSelectionChange = (e) => {
    const selectedClassId = parseInt(e.target.value);
    const selectedOption = classList.find((option) => option.id === selectedClassId);
    setSelectedClassName(selectedOption.name);
    setSelectedClassIds(selectedClassId);
    setIsClassChanged(!isClassChanged);
  };

  const handleIncompleteScoringOptionChange = async (e) => {
    let data = {
      incompleteScoring: e.target.checked
    };
    try {
      await patchAssignmentIncompleteScoringOption(data).unwrap();
      setIncompleteScoringOption(data.incompleteScoring);
      await fetchScoreReportData();
    } catch (error) {
      console.log(error);
    }
  };

  const pointOptionHandleChange = async (e) => {
    let option;
    if (e.target.id==='radioPoints') {
      option = {
        option: true
      };
    } else {
      option = {
        option: false
      };
    }

    setScoringOption({
      point: option.option,
      percentage: !option.option
    });

    try {
      await patchAssignmentPointsOPtions(option).unwrap();
      await fetchScoreReportData();
    } catch (err) {
      console.log(err);
    }
  };

  if (pageLoader) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: '40px' }}>
        <HesSpinner />
        <span className="ms-3">Loading results...</span>
      </div>
    );
  }

  const handlePrintPdf = async () => {
    const scoringOptionSave = scoringOption;

    // Generate the PDF from the HTML content
    const contentWrapper = document.getElementById('session_pdf_Wrapper');
    const contentClone = contentWrapper.cloneNode(true);
    const buttonGroup = contentClone.querySelector('#buttonGroup');
    buttonGroup.classList.add('d-none');
    const dropDownContainer = contentClone.querySelector('#dropdown_container');
    dropDownContainer.classList.add('d-none');
    const tables = document.getElementsByTagName('table');

    // Apply CSS styles to tables
    for (let i = 0; i < tables.length; i++) {
      const table = tables[i];
      table.style.pageBreakInside = 'avoid';
      table.style.breakInside = 'avoid';
      table.style.keepWithWindow = 'always';
    }

    // Apply CSS styles to div

    const options = {
      margin: 60, // Specify the margin for all sides (top, right, bottom, left)
      image: { type: 'jpeg', quality: 0.98 }, // Set the image type and quality (optional)
      html2canvas: { scale: 2 }, // Set the scale for better quality (optional)
      jsPDF: { unit: 'pt', format: 'a3', orientation: 'landscape' }, // Set the document format and orientation (optional)
      pagebreak: {
        mode: ['avoid-all', 'css', 'legacy']
      }
    };

    await html2pdf().set(options).from(contentClone).save('ScoreReport.pdf');

    setScoringOption({
      point: scoringOptionSave.point,
      percentage: scoringOptionSave.percentage
    });
  };

  const exportHandler = async () => {
    const newObjectWithNewProperties = {
      Assignment: ScoreReportData.assignment || 'Assignment Name',
      Course: ScoreReportData.course,
      Teacher: ScoreReportData.teacher,
      SchoolName: ScoreReportData.school,
      Class: ScoreReportData.class,
      'Report Date': Date().toLocaleString()
    };

    const studentList = [];

    ScoreReportData.individualResult.forEach((student) => {
      const lastName = ferpaEnabled ? student.lastName : 'Lastname hidden';
      const firstName = ferpaEnabled ? student.firstName : 'Firstname hidden';
      const identification = ferpaEnabled ? student.identification : 'Id hidden';
      const dateAssigned = student.dateAssigned;
      const dateStarted = student.dateStarted;
      const dateCompleted = student.dateCompleted;
      const correct = student.correct;
      const incorrect = student.incorrect;
      const correctOnRetry = student.correctOnRetry;
      const crAnswered = student.crAnswered;
      const score = student.score;
      const scoreWithFullCredit = student.scoreWithFullCredit;
      const scoreWithHalfCredit = student.scoreWithHalfCredit;

      studentList.push({
        LastName: lastName,
        FirstName: firstName,
        Identification: identification,
        DateAssigned: dateAssigned,
        DateStarted: dateStarted,
        DateCompleted: dateCompleted,
        Correct: correct,
        Incorrect: incorrect,
        CorrectOnRetry: correctOnRetry,
        CRAnswered: crAnswered,
        Score: score,
        ScoreWithFullCredit: scoreWithFullCredit,
        ScoreWithHalfCredit: scoreWithHalfCredit
      });      
    });

    const newData = {
      ReportOptions : newObjectWithNewProperties,
      ScoresReport: studentList
    };

    const newDataWithReportOptionsFirst = reorderObjectProperties(newData, 'ReportOptions');
    const csvData = convertToCSV(newDataWithReportOptionsFirst);
    downloadCSV(csvData, 'Scores Report-' + ScoreReportData.assignment );
  };

  return (
    <div className="white-card" id="session_pdf_Wrapper">
      <div className="student_response_header">
        <div>
          <h3>Assignment Scores Report</h3>
        </div>
        <div id="buttonGroup" className="d-flex justify-content-between" style={{ width: '450px' }}>
          <button
            onClick={() => setShowFerpa(!showFerpa)}
            className="btn-link primary-link"
            style={{ float: 'right' }}>
            <FontAwesomeIcon icon={faCircleInfo} /> FERPA
          </button>
          {showFerpa && (
            <div className="d-flex flex-row ferpaMessage scoreFerpa">
              <div className="d-flex flex-column">
                <p>
                  Student identification information should not be printed or displayed publicly or
                  emailed as per FERPA requirements.
                </p>
                <a
                  href="https://www2.ed.gov/policy/gen/guid/fpco/ferpa/index.html"
                  target="_blank"
                  className="link-orange"
                  style={{ marginBottom: '16px' }}
                  rel="noreferrer">
                  Family Educational Rights and Privacy Act (FERPA)
                </a>
                <Form.Check
                  type="checkbox"
                  id="displayStudentNames"
                  className="d-flex flex-row align-items-center">
                  <Form.Check.Input
                    type="checkbox"
                    defaultChecked={ferpaEnabled}
                    style={{ marginRight: '5px' }}
                    onClick={(e) => handleFerpaChange(e)}
                  />
                  <Form.Check.Label>Display Student Names/Identification</Form.Check.Label>
                </Form.Check>
              </div>
              <FontAwesomeIcon
                color="#525252"
                style={{ fontSize: '20px', cursor: 'pointer' }}
                icon={faX}
                onClick={() => setShowFerpa(false)}
              />
            </div>
          )}
          <button id="back_button" onClick={() => navigate(-1)} className="btn btn-width btn-castleWhite">
            Back
          </button>
          <button id="export_button" onClick={() => exportHandler()} className="btn btn-width btn-castleOrange">
              Export
          </button>
          <button id="print_button" className="btn btn-castleRed" onClick={handlePrintPdf}>
            Print to PDF
          </button>
        </div>
      </div>
      <div id="dropdown_container" className="d-flex flex-column justify-content-start" style={{ width: '30%' }}>
        Class
        <DropDown
          value={classList}
          selectedValue={selectedClassIds}
          onChangeHandler={handleClassSelectionChange}
        />
      </div>
      <div id="print-score-report">
        <div className="student_response_details">
          <div className="d-flex justify-content-between">
            <div className="student_response_details_left">
              <p>
                Assignment: <strong>{ScoreReportData?.assignment}</strong>
              </p>
              <p>
                Course: <strong>{ScoreReportData?.course}</strong>
              </p>
              <p>
                Teacher: <strong>{ScoreReportData?.teacher}</strong>
              </p>
            </div>
            <div className="student_response_details_right">
              <p>
                School: <strong>{ScoreReportData?.school}</strong>
              </p>
              <p>
                Class:{' '}
                <strong>
                  {selectedClassName !== '' ? selectedClassName : ScoreReportData?.class}
                </strong>
              </p>
              <p>
                Report Date: <strong>{ScoreReportData?.reportDate}</strong>
              </p>
            </div>
          </div>
        </div>
        <div className="score-report">
          <div>
            <p>Show score as</p>
          </div>
          <div className="d-flex">
            <div className="d-flex gap-1 me-3">
              <input
                type="radio"
                className="form-check-input"
                checked={scoringOption.point}
                id="radioPoints"
                name="flexRadioDefault"
                onChange={(e) => pointOptionHandleChange(e)}
              />
              <label className="form-check-label">
                Points
              </label>
            </div>
            <div className="d-flex gap-1">
              <input
                type="radio"
                className="form-check-input"
                checked={scoringOption.percentage}
                id="radioPercentage"
                name="flexRadioDefault"
                onChange={(e) => pointOptionHandleChange(e)}
              />
              <label className="form-check-label">
                Percentage
              </label>
            </div>
  
            <div className="ms-5">
              <input
                type="checkbox"
                className="form-check-input me-2"
                checked={incompleteScoringOption}
                id="flexCheckDefault"
                name="allselect"
                onChange={handleIncompleteScoringOptionChange}
              />
              <label className="form-check-label">
                Score unanswered questions as incorrect
              </label>
            </div>
          </div>
        </div>
        <div className="mt-5" style={{width:'100%'}}>
          <table className={'w-100'}>
            <tr className="score-table-head">
              <th>Last Name</th>
              <th>First Name</th>
              <th>Identification</th>
              <th>Date<br></br>Assigned</th>
              <th>Date<br></br>Started</th>
              <th>Date<br></br>Completed</th>
              <th>
                <FontAwesomeIcon icon={faCheck} />
              </th>
              <th>
                <FontAwesomeIcon icon={faClose} />
              </th>
              <th>
                <FontAwesomeIcon icon={faClose} /><FontAwesomeIcon icon={faCheck} /> 
              </th>
              <th>CR<br></br>Answered</th>
              <th>Score</th>
              <th>Score With Retry<br></br>As Full-Credit</th>
              <th>Score With Retry<br></br>As Half-Credit</th>
            </tr>
            {!loader ? (
              <>
                {!isNoData?(
                  <>
                    {ScoreReportData?.individualResult?.map((item) => (
                      <tr className="tabel-body" key={`${item.studentId}-record`}>
                        {ferpaEnabled?<td>{item.lastName}</td>:<td>Lastname<br></br>hidden</td>}
                        {ferpaEnabled?<td>{item.firstName}</td>:<td>Firstname<br></br>hidden</td>}
                        {ferpaEnabled?<td>{item.identification}</td>:<td>Id<br></br>hidden</td>}
                        <td>{item.dateAssigned}</td>
                        <td>{item.dateStarted}</td>
                        <td>{item.dateCompleted}</td>
                        <td>{item.correct}</td>
                        <td>{item.incorrect}</td>
                        <td>{item.correctOnRetry}</td>
                        <td>{item.crAnswered}</td>
                        <td>{item.score}</td>
                        <td>{item.scoreWithFullCredit}</td>
                        <td>{item.scoreWithHalfCredit}</td>
                      </tr>
                    ))}
                  </>
                ):(
                  <>
                    <tr className="tabel-body" style={{height:'200px'}}>
                    </tr>
                  </>
                )}
              </>
            ):(
              <tr className="tabel-body" style={{height:'200px'}}>
                <td colSpan={13}>
                  <div className="d-flex justify-content-center align-items-center" style={{ height: '200px' }}>
                    <div id="spinnerdiv" style={{height:'30px'}}>
                      <HesSpinner />
                    </div>
                    <span className="ms-3">Loading results...</span>
                  </div>
                </td>
              </tr>
            )}
          </table>
        </div>
      
        <div className="scoreInfo d-flex col-12">
          <div className="scoreInfoIcon info-text">
            <span>
              <FontAwesomeIcon icon={faInfo} />
            </span>
          </div>
          <div className="scoreInfoText">
            <p>
              <strong>Score:</strong> counts only the first answer attempt as correct
            </p>
            <p>
              <strong>Score With Retry As Full-Credit:</strong> counts correct answers on a retry as
            full-credit
            </p>
            <p>
              <strong>Score With Retry As Half-Credit:</strong> counts correct answers on a retry as
            half-credit
            </p>
            <p>All percent scores rounded to nearest whole number</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ScoreReport;
